import styled from "styled-components";
import C from "@assets/themes/colors";

export const Root = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

export const ExplorerContainer = styled.div`
  max-height: 300px;
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  flex-direction: row;
`;

export const ItemContainer = styled.div`
  width: 100%;  
  margin: 5px 5px 5px 50px;
  display:flex;
  flex-direction: row;
  align-items: center;
`;

export const AssetInputName = styled.input`
  width: 250px;  
  height: 12px;
  flex-grow: 0;
  margin: 10px;
  padding: 12px 47px 12px 10px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px rgba(0, 0, 0, 0.2);
  background-color: var(--white);
   
`;

export const AssetImage = styled.img`
  width: 64px;
  height: 47px;
  margin:10px;
  border-radius: 5px;
  background-color: rgba(18, 36, 66, 0.3);
  object-fit: cover;
`;


export const AssetOverwrite = styled.div`
  width: 150px;  
  
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #122442;  
  margin: 0px 1px 2px 98px;
  padding: 10px 11px 10px 9px;  
  border-radius: 5px;
  &:hover {
    background-color: rgba(18, 36, 66, 0.1);
  }

  
`;

export const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0px 29px 39px;
`;

export const ActionsContainer = styled.div`
  display: flex;
`;